<script setup lang="ts">
import MenuLink from '@layout/nav-v2/mobile/components/MenuLink.vue';
import { URL_SEARCH, URL_USER_INBOX, URL_USER_PROPOSAL } from '@tools/routes/routes';
import { trans } from '@elements/translation.ts';
import IconManifyingGlass from '@icons/ph_magnifying-glass.svg';
import IconEnvelope from '@icons/ph_envelope.svg';
import IconHeartStraight from '@icons/ph_heart-straight.svg';
import Icon from '@components/Icon.vue';
import { storeToRefs } from 'pinia';
import { useNavbarStore } from '@stores/layout/useNavbarStore';

const { notifications } = storeToRefs(useNavbarStore());
</script>

<template>
  <li>
    <MenuLink :link="URL_SEARCH">
      <template #icon="{ isActive }">
        <Icon
          :svg="IconManifyingGlass"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.search') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <MenuLink
      :link="URL_USER_INBOX"
      :has-pin="notifications.unread_messages > 0"
      data-cy-ref="navbar-mobile__link--inbox"
    >
      <template #icon="{ isActive }">
        <Icon
          :svg="IconEnvelope"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.inbox') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <MenuLink
      :link="URL_USER_PROPOSAL"
      :has-pin="notifications.unread_match_proposal > 0"
    >
      <template #icon="{ isActive }">
        <Icon
          :svg="IconHeartStraight"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.selection_item') }}
      </template>
    </MenuLink>
  </li>
</template>
